import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';

import Checkout from './Checkout';

import { IInitialState } from 'src/store/initialState';
import {
  checkoutIsPendingSel,
  checkoutOrderConfirmedSel,
  checkoutCreditCardUrlSel,
  checkoutConfirmationNumberSel,
  checkoutCodeSel,
  checkoutItemsSel,
  checkoutItemCountSel,
  checkoutDeliverMethodSel,
  checkoutDeliveryLocationCode,
  checkoutDeliveryLocationSel,
  checkoutSubtotalSel,
  checkoutTax,
  checkoutTotal,
  checkoutErrorSel,
  checkoutActions,
  checkoutDefaultMOT,
  checkoutTermsOfDelivery,
  checkoutPendingOrderNumberSel,
  checkoutSoftCreditHoldSel
} from 'src/store/modules/checkout';
import { userActions, userDataSel } from 'src/store/modules/user';
import {
  creditCardActions,
  savedCreditCardsSel,
  selectedCardSel
} from 'src/store/modules/creditcard';
import { ICartServiceItem } from 'src/services/cart/CartService';
import { cartActions } from 'src/store/modules/cart';
import CreditCardModel from 'src/model/creditCard.model';
import { IShippingMethod } from 'src/services/checkout/CheckoutService';
import {
  deliveryStateSel,
  accountViewActions
} from 'src/store/modules/accountview';
import { analyticsActions } from 'src/analytics/store';

interface IDispatchFromProps {
  onLoad(): void;
  onPlaceOrder(
    checkoutCode: number,
    confirmationEmail: boolean,
    deliverSameTime: boolean,
    paymentMethod: string,
    poNumber: string,
    shippingMethod: IShippingMethod,
    saveCard: boolean,
    unitNumber: string,
    serviceNumber: string,
    techNumber: string
  ): void;
  onConfirmOrder(
    paymentConfirmation: string,
    pendingOrderId: number,
    saveCard: boolean
  ): void;
  onReorder(items: ICartServiceItem[], onFinish: () => void): void;
  onSelectCreditCard(creditCard: CreditCardModel): void;
  onClosePoNumberAlert: () => void;
  getPaymentMethodForCheckout(data: any): void;
}

const mapStateToProps = (state: IInitialState) => ({
  isPending: checkoutIsPendingSel(state),
  orderConfirmed: checkoutOrderConfirmedSel(state),
  creditCardUrl: checkoutCreditCardUrlSel(state),
  pendingOrderNumber: checkoutPendingOrderNumberSel(state),
  confirmationNumber: checkoutConfirmationNumberSel(state),
  checkoutCode: checkoutCodeSel(state),
  items: checkoutItemsSel(state),
  itemCount: checkoutItemCountSel(state),
  deliverMethod: checkoutDeliverMethodSel(state),
  deliveryLocationCode: checkoutDeliveryLocationCode(state),
  deliveryLocation: checkoutDeliveryLocationSel(state),
  subtotal: checkoutSubtotalSel(state),
  tax: checkoutTax(state),
  total: checkoutTotal(state),
  defaultMOT: checkoutDefaultMOT(state),
  termsOfDelivery: checkoutTermsOfDelivery(state),
  userData: userDataSel(state),
  error: checkoutErrorSel(state),
  savedCreditCards: savedCreditCardsSel(state),
  selectedCreditCard: selectedCardSel(state),
  softCreditHold: checkoutSoftCreditHoldSel(state),
  deliveryStatus: deliveryStateSel(state)
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onLoad: () => {
    dispatch(checkoutActions.getInfo());
    dispatch(userActions.getUserDetails());
    dispatch(creditCardActions.getSavedCards());
    dispatch(accountViewActions.getDeliveryStatus());
    dispatch(analyticsActions.getPaymentMethodForCheckout('001'));
  },
  onPlaceOrder: (
    checkoutCode: number,
    confirmationEmail: boolean,
    deliverSameTime: boolean,
    paymentMethod: string,
    poNumber: string,
    shippingMethod: IShippingMethod,
    saveCard: boolean,
    unitNumber: string,
    serviceNumber: string,
    techNumber: string
  ) => {
    dispatch(
      checkoutActions.placeOrder(
        checkoutCode,
        confirmationEmail,
        deliverSameTime,
        paymentMethod,
        poNumber,
        shippingMethod,
        saveCard,
        unitNumber,
        serviceNumber,
        techNumber
      )
    );
  },
  onConfirmOrder: (
    paymentConfirmation: string,
    pendingOrderId: number,
    saveCard: boolean
  ) => {
    dispatch(
      checkoutActions.confirmOrder(
        paymentConfirmation,
        pendingOrderId,
        saveCard
      )
    );
  },
  onReorder: (items: ICartServiceItem[], onFinish: () => void) => {
    dispatch(cartActions.addItems(items, onFinish));
  },
  onSelectCreditCard: (creditCard: CreditCardModel) => {
    dispatch(creditCardActions.setSelectedCard(creditCard));
  },
  onClosePoNumberAlert: () => {
    dispatch(
      checkoutActions.setError({
        hasFailed: false,
        message: ''
      })
    );
  },
  getPaymentMethodForCheckout: (data: any) =>
    dispatch(analyticsActions.getPaymentMethodForCheckout(data))
});

export const pureComponent = Checkout;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(Checkout as any)));
